import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {
    ApplicationEmptyState
} from 'core/components';
import {PreviewLayout} from 'core/layouts';
import { toPhoneNumber, emailRecipientTypes } from 'core/utils';
import { BaasicButton, BaasicDropdown } from 'core/components';
function FacilityPreviewTemplate({ facilityPreviewViewStore, t }) {
    const {
        previewCorporate,
        item,
        loaderStore,
        facilityStore,
        nextDeliveryDate,
        nextOrderingDate,
        dateOfService,
        facilityAdditionalContact,
        rootStore,
        routes
    } = facilityPreviewViewStore;

    const areasOfCares = item ? item.facilityAreaOfCares.map(item =>    
        <tr key={item.areaOfCareId}>
            <td><React.Fragment>{item.areaOfCare.name}</React.Fragment></td>
            <td><React.Fragment>{item.coverageType.name}</React.Fragment></td>
        </tr>
    ) : [];
    let contactsRows = item && item.corporate_ && item.corporate_.corporateContacts != null && item.corporate_.corporateContacts.map(contact => {
        return (<tr key={contact.id}>
            <td className="col-lrg-2">
                {contact.name}
            </td>
            <td className="col-lrg-2">
                {contact.lastName}
            </td>
           <td className="col-lrg-2">
                {contact.corporateContactContactDepartments &&
                contact.corporateContactContactDepartments.length > 0
                    ? contact.corporateContactContactDepartments
                        .map(rel => rel && rel.contactDepartment && rel.contactDepartment.name)
                        .join(', ')
                    : ''}
            </td>
            <td className="col-lrg-2">
                {toPhoneNumber(contact.phone)}
            </td>
            <td className="col-lrg-2">
                {contact.email}
            </td>
             <td className="col-lrg-2">
                {contact.position}
            </td>
            <td className="col-lrg-2 type--center">
                <span className={'u-icon u-icon--sml' + ( contact.specialOrders ? ' u-icon--active' : '')}></span>
            </td>
            <td className="u-cursor--default type--left">
                {emailRecipientTypes.map((setting) => {
                    return contact[setting.field] && contact[setting.field] !== '' && <div className={'status--include is-'  + contact[setting.field]}>{setting.name}</div>
                })}
            </td>
        </tr>)
    });

    let additionalContactsRows = facilityAdditionalContact != null ? facilityAdditionalContact.filter(i => !i.inActive).map(contact => {
        return (<tr key={contact.id} className={contact.inActive ? 'inactive':''}>
            <td>
                {contact.name}
            </td>
             <td>
                {contact.lastName}
            </td>
            <td>
                {contact.departments}
            </td>
            <td>
                {contact.email}
            </td>
            {/* <td>
                {toPhoneNumber(contact.phone)}
            </td>
            <td>
                {contact.extension}
            </td> */}
            <td className="wrap">
                {contact.note}
            </td>
            <td className="u-cursor--default type--left">
                
                { emailRecipientTypes.map((setting) => {
                   return contact[setting.field] && contact[setting.field] !== '' && <div className={'status--include is-'  + contact[setting.field]}>{setting.name}</div>
                })} 
            </td>
            <td className="type--center">
                <i className={`u-icon u-icon--${contact.inActive ? 'inactive-grey':'active-blue'} u-icon--sml`} title={contact.inActive ? 'Inactive':'Active'}></i>
            </td>
        </tr>)
    }) : null;

    let additionalInactiveContactsRows = facilityAdditionalContact != null ? facilityAdditionalContact.filter(i => i.inActive).map(contact => {
        return (<tr key={contact.id} className={contact.inActive ? 'inactive':''}>
            <td>
                {contact.name}
            </td>
            <td>
                {contact.lastName}
            </td>
            <td>
                {contact.departments}
            </td>
            <td>
                {contact.email}
            </td>
            <td className="wrap">
                {contact.note}
            </td>
            <td className="u-cursor--default type--left">
                {emailRecipientTypes.map((setting) => {
                    return contact[setting.field] && contact[setting.field] !== '' && <div className={`status--include ${contact.inActive ? 'is-inactive' : `is-${contact[setting.field]}`}`}>{setting.name}</div>
                })} 
            </td>
            <td className="type--center">
                <i className={`u-icon u-icon--${contact.inActive ? 'inactive-grey':'active-blue'} u-icon--sml`} title={contact.inActive ? 'Inactive':'Active'}></i>
            </td>
        </tr>)
    }) : null;

    return (
        <PreviewLayout store={facilityPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            {item && item.payersNeedAttention &&
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                            <div className="u-flex--space-between">
                                <div>
                                    <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                    {t('FACILITY.PAYERS_NEED_ATTENTION')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            <div className="u-mar--bottom--sml">
                <div className="row">
                    <div className="col col-sml-12 col-med-6 col-lrg-6 col-xxlrg-4">
                        <div className="inputgroup">
                            <div className="inputgroup--main">
                                <BaasicDropdown 
                                    store={facilityStore}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med">
                        <div className="u-mar--bottom--med">
                            <div className="card__header">
                                <h3 className="card__header__title">
                                    {item && <React.Fragment>{item.name}</React.Fragment>}
                                </h3>
                                <div className="card__header__actions">
                                    <BaasicButton
                                        className="btn btn--icon"
                                        icon="u-icon u-icon--med u-icon--schedules"
                                        label="Calendar"
                                        onlyIcon={true}
                                        onClick={() => 
                                            window.open(
                                                `${rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${item.id}`
                                            )}
                                    ></BaasicButton>
                                    <BaasicButton
                                        className='btn btn--icon'
                                        icon="u-icon u-icon--med u-icon--edit--dark"
                                        onlyIcon={true}
                                        label="Edit"
                                        onClick={() => routes.edit()}
                                    />
                                    <div className="u-flex--grow--1 type--right">
                                        <BaasicButton
                                            className="btn btn--base btn--primary"
                                            label="History"
                                            onClick={() => 
                                                window.open(
                                                    `${rootStore.routerStore.findRoute('master.app.main.facility.facility-history.list').pattern}?facilityId=${item.id}`
                                                )}
                                        ></BaasicButton>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col col-sml-12 col-med-4">
                                    <div className="form__group w--max--200">
                                        <label className="form__group__label">Address:</label>
                                        {item && <p>{item.address}</p>}
                                    </div>
                                    <div className="form__group">
                                        <label className="form__group__label">Phone:</label>
                                        {item && <p>{item.phone} {item.timeZone}</p>} 
                                    </div>
                                </div>

                                <div className="col col-sml-12 col-med-4">
                                    <div className="form__group">
                                        <label className="form__group__label">Next Ordering Date:</label>
                                        <p>{ nextOrderingDate != "01/01/0001" && nextOrderingDate != null ? nextOrderingDate : null}</p>
                                    </div>
                                    <div className="form__group">
                                        <label className="form__group__label">Date Of Service:</label>
                                        <p>{ dateOfService != "01/01/0001" && dateOfService != null ? dateOfService : null }</p>
                                    </div>
                                    <div className="form__group">
                                        <label className="form__group__label">Next Delivery Date:</label>
                                        <p>{ nextDeliveryDate != "01/01/0001" && nextDeliveryDate != null ? nextDeliveryDate : null}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview">General Info</h4>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.ACTIVE_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && !item.inActive ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.IS_NEW_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isNew ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.IS_NEW_FLOW_2_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isNewFlow2 ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.IS_ON_HOLD_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isOnHold ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.ACCOUNT_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.accountRep && <React.Fragment>{item.accountRep.firstName + ' ' + item.accountRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.BILLING_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.billingRep && <React.Fragment>{item.billingRep.firstName + ' ' + item.billingRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.DOCUMENT_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.documentRep && <React.Fragment>{item.documentRep.firstName + ' ' + item.documentRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.PAYOR_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.payorRep && <React.Fragment>{item.payorRep.firstName + ' ' + item.payorRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">2nd Payor Check Required</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.requiredSecondPayor ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.INTAKE_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.intakeRep && <React.Fragment>{item.intakeRep.firstName + ' ' + item.intakeRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.INITIAL_INTAKE_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.initialIntakeRep && <React.Fragment>{item.initialIntakeRep.firstName + ' ' + item.initialIntakeRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.INSURANCE_REVIEW_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.insuranceReviewRep && <React.Fragment>{item.insuranceReviewRep.firstName + ' ' + item.insuranceReviewRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.WOUND_CARE_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.woundCareRep && <React.Fragment>{item.woundCareRep.firstName + ' ' + item.woundCareRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.PURCHASE_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.purchaseRep && <React.Fragment>{item.purchaseRep.firstName + ' ' + item.purchaseRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.CONFIRMING_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.confirmingRep && <React.Fragment>{item.confirmingRep.firstName + ' ' + item.confirmingRep.lastName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.JURISDICTION_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && item.jurisdiction && <React.Fragment>{item.jurisdiction}</React.Fragment>}
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.CBA_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && typeof item.cba === 'boolean' && <i className={`u-icon u-icon--sml u-icon--${item.cba ? 'active' : 'inactive'}`}></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.BRANCH_OFFICE_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.branch && <React.Fragment>{item.branch.name}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.ACCOUNT_NUMBER_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                        {item && item.masterPatientId && <React.Fragment>{item.masterPatientId}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.FASTCARE_ID_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.fastcareId && <React.Fragment>{item.fastcareId}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.EMERGENCY_SUPPLY_DAYS_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.emergencySupplyDays}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.PAYOR_INFORMATION_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.payorInformation}</React.Fragment>}
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.PARTB_ONLY_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.partBOnly ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.PUMPS_NOT_SET_INITIALLY_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.pumpsNotSetInitially ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.IS_PUMP_RENTAL_ITEM_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isPumpRentalItem ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.IS_AUTO_SUPPLY_ENFIT_ADAPTE_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isAutoSupplyEnfitAdapter ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.INVOICED_MONTHLY')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.invoicedMonthly ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.DO_NOT_SEND_IV_POLES')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.doNotSendIVPoles ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.SEND_AGORA_PO')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.sendAgoraPo ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.IS_MONTHLY_TRACH_TUBE')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isMonthlyTrachTube ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.DOCUMENTATION_HOLD')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.documentationHold ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.SAPs')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isSAPs ? <i className="u-icon u-icon--sml u-icon--active"></i> : <i className="u-icon u-icon--sml u-icon--inactive"></i>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.PRICE_TABLE_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.priceTable}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">PRICING GROUP</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.pricingGroup && item.pricingGroup.name}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.MARKETING_REP_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.marketingRep}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.SHIPPING_VENDOR_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.shippingVendor}
                                        </div>
                                    </div>
                                </div>
                            </div>              
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.SHIP_POINT_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.shipPoint}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('FACILITY.EDIT.SHIP_POINT_UNITED_LABEL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.shipPointUnited}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.MAIN_VENDOR_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && item.mainVendor && item.mainVendor.name}
                                    </div>
                                </div>
                            </div>
                        </div>          
                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview">Default Products</h4>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.PUMP_BRAND_LABEL')}</div> 
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.pumpBrand_ && item.pumpBrand_.name}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.SPIKE_SET_LABEL')}</div>  
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.spikeSet_ && item.spikeSet_.itemId}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.SYRINGE_LABEL')}</div> 
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.syringe_ && item.syringe_.itemId}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.DRAINAGE_BAG_LABEL')}</div> 
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.drainageBag_ && item.drainageBag_.itemId}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview">Areas of Care</h4>
                            <div className="table--preview__wrap">
                                <table className="table--preview">
                                    <thead >
                                        <tr>
                                            <th>Area of Care</th>
                                            <th>Coverage type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {areasOfCares}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    
                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview">EMR Info</h4>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.EMR_LABEL')}</div> 
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.emr}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.EMR_ACCOUNT_NAME_LABEL')}</div>  
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.emrAccountName}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.EMR_USERNAME_LABEL')}</div> 
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.emrUserName}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.EMR_PASSWORD_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        {item && <React.Fragment>{item.emrPassword}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">{t('FACILITY.EDIT.UNIQUE_CODE_LABEL')}</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6">
                                    {item && <React.Fragment>{item.uniqueCode}</React.Fragment>}
                                </div>
                            </div>
                        </div>
                        <h4 className="form__title form__title--preview">Contacts</h4>
                        {item && item.facilityAdditionalContact.length != 0 &&
                            <div className="u-mar--bottom--med">
                                {additionalContactsRows && additionalContactsRows.length > 0 &&
                                    <div className="table--preview__wrap">
                                        <table className="table--preview">
                                            <colgroup>
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col width="160" />
                                                <col width="66" />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th className="type--left">First Name</th>
                                                    <th className="type--left">Last Name</th>
                                                    <th className="type--left">Department</th>
                                                    <th className="type--left">Email</th>
                                                    {/* <th className="type--left">Phone</th>
                                                    <th className="type--left">Extension</th> */}
                                                    <th className="type--left">Note</th>
                                                    <th className="type--left">Include On</th>
                                                    <th className="type--left">Active</th>
                                                </tr>
                                            </thead>
                                            <tbody>{additionalContactsRows}</tbody>
                                        </table>
                                    </div>
                                }
                            </div>
                        }
                        {additionalInactiveContactsRows && additionalInactiveContactsRows.length > 0 && (
                          <CollapsibleSection title="Contacts" defaultCollapsed={true}>
                           <div className="table--preview__wrap">
                                        <table className="table--preview">
                                            <colgroup>
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col />
                                                <col width="160" />
                                                <col width="66" />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th className="type--left">First Name</th>
                                                    <th className="type--left">Last Name</th>
                                                    <th className="type--left">Department</th>
                                                    <th className="type--left">Email</th>
                                                    <th className="type--left">Note</th>
                                                    <th className="type--left">Include On</th>
                                                    <th className="type--left">Active</th>
                                                </tr>
                                            </thead>
                                            <tbody>{additionalInactiveContactsRows}</tbody>
                                        </table>
                                    </div>
                          </CollapsibleSection>
                        )}
                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview"> {t('FACILITY.EDIT.CORPORATE_LABEL')}: 
                                <a onClick= {() => previewCorporate(item.corporateId)} > { item && item.corporate_ && item.corporate_.name}</a>
                            </h4>

                            <div className="u-mar--bottom--med type--whitespace--preline type--break-all">
                                <strong>Description:</strong> {item && item.corporate_ && <React.Fragment>{item.corporate_.description}</React.Fragment>}
                            </div>

                            <div className="u-separator--preview">
                                <div className="row row--align--center">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('CORPORATE.EDIT.SPECIAL_REQUESTS_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                        {item && item.corporate_ && item.corporate_.specialRequests}
                                    </div>
                                </div>
                            </div>

                            <div className="u-separator--preview">
                                <div className="row row--align--center">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('CORPORATE.EDIT.SPECIAL_ORDERS_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        <span className={'u-icon u-icon--sml' + ( item && item.corporate_ && item.corporate_.specialOrders ? ' u-icon--active' : '')}></span>
                                    </div>
                                </div>                                
                            </div>

                            <div className="u-separator--preview">
                                <div className="row row--align--center">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('CORPORATE.EDIT.APPROVAL_REQUIRED_EXTRA_SUPPLIES_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6">
                                        <span className={'u-icon u-icon--sml' + ( item && item.corporate_ && item.corporate_.approvalRequiredExtraSupplies ? ' u-icon--active' : '')}></span>
                                    </div>
                                </div>
                            </div>

                            {item && item.corporate_ && item.corporate_.corporateContacts && item.corporate_.corporateContacts.length != 0 &&
                                <div className="u-mar--bottom--med">
                                    <h4 className="form__title form__title--preview">Corporate Contacts</h4>
                                    {contactsRows &&
                                    <div className="table--preview__wrap">
                                        <table className="table--preview u-mar--bottom--med">
                                            <thead>
                                                <tr>
                                                    <th className="type--left">First Name</th>
                                                    <th className="type--left">Last Name</th>
                                                    <th className="type--left">Department</th>
                                                    <th className="type--left">Phone</th>
                                                    <th className="type--left">Email</th>
                                                    <th className="type--left">Note</th>
                                                    <th className="type--center w--75--px">Special Order</th>
                                                    <th className="type--left w--140--px">Include On</th>
                                                </tr>
                                            </thead>
                                            <tbody>{contactsRows}</tbody>
                                        </table>
                                    </div>
                                    }
                                </div>
                            }
                        </div>
                        <div className="u-mar--bottom--med">
                            <h4 className="form__title form__title--preview">Notes</h4>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.NOTES_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                        {item && <React.Fragment>{item.notes}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.DELIVERYNOTE_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                        {item && <React.Fragment>{item.deliveryNote}</React.Fragment>}
                                    </div>
                                </div>
                            </div>  
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-6">
                                    <div className="form__group__label is-preview">{t('FACILITY.EDIT.GENERAL_NOTE_LABEL')}</div>
                                </div>
                                <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                    {item && <React.Fragment>{item.generalNote}</React.Fragment>}
                                </div>
                            </div>
                        </div>
                        <div>
                            <h4 className="form__title form__title--preview">E-Sign</h4>
                            <div className="u-separator--preview">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.ESIGN_PREFERENCE_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                        {item && <React.Fragment>{item.eSignPreference && item.eSignPreference.name}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="row">
                                    <div className="col col-sml-12 col-lrg-6">
                                        <div className="form__group__label is-preview">{t('FACILITY.EDIT.ESIGN_NOTE_LABEL')}</div>
                                    </div>
                                    <div className="col col-sml-12 col-lrg-6 type--whitespace--preline type--break-all">
                                        {item && <React.Fragment>{item.eSignNote}</React.Fragment>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PreviewLayout>
    )
}

class CollapsibleSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: props.defaultCollapsed !== undefined ? props.defaultCollapsed : true };
  }

  toggle = () => {
    this.setState(function(prevState) {
      return { collapsed: !prevState.collapsed };
    });
  };

  render() {
    const children = this.props.children;
    const collapsed = this.state.collapsed;

    return ( 
      <div className="u-mar--bottom--med">
        <div className={!collapsed ? "u-mar--bottom--sml" : ""} style={{display: 'inline-block', cursor: 'pointer'}}  onClick={this.toggle}>
            <span>Inactive Contacts</span>
            <span className={!collapsed ? "u-icon u-icon--med u-icon--arrow-up u-mar--left--sml" : "u-icon u-icon--med u-icon--arrow-down u-mar--left--sml"}></span>
        </div>              
         {!collapsed && (
            <div>
                {children}
            </div>
        )}
      </div>
    );
  }
}

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  defaultCollapsed: PropTypes.bool,
  children: PropTypes.node
};

FacilityPreviewTemplate.propTypes = {
    facilityPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(FacilityPreviewTemplate);
